/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'arrow': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<g _stroke="currentColor" _fill="none" fill-rule="evenodd"><path pid="0" d="M15 6.5H0M12 10l3-3.446L12 3"/></g>'
  }
})
